import { useState, ReactNode } from 'react';

import {
  FullscreenGalleryContext,
  type FullscreenGalleryContextType,
} from './FullscreenGalleryContextTypes';

interface FullscreenGalleryProviderProps {
  children: ReactNode;
}

export const FullscreenGalleryProvider = ({ children }: FullscreenGalleryProviderProps) => {
  const [isGalleryFullscreen, setIsGalleryFullscreen] = useState(false);
  const [isLogoLightboxOpen, setIsLogoLightboxOpen] = useState(false);

  const value: FullscreenGalleryContextType = {
    isGalleryFullscreen,
    setIsGalleryFullscreen,
    isLogoLightboxOpen,
    setIsLogoLightboxOpen,
  };

  return (
    <FullscreenGalleryContext.Provider value={value}>{children}</FullscreenGalleryContext.Provider>
  );
};
